/* src/app/commonComponents/modals/default-modals/settings-library-modal/activity-type-modal/activity-type-modal.component.scss */
.input-container.checkbox-container label {
  display: inline-flex;
}
.input-container.checkbox-container label .j2-icon-info {
  margin-left: 5px;
}
.modal-template .modal-body {
  padding: 0;
}
.custom-rates-container {
  position: relative;
}
.custom-rates-container ::ng-deep app-rates .left-item {
  flex: 1;
}
.custom-rates-container ::ng-deep app-rates .right-item {
  width: 90px;
}
.custom-rates-container ::ng-deep app-rates .app-rates > :first-child .text-select-field {
  width: 100%;
}
.custom-rates-container ::ng-deep app-rates .app-rates .text-select-field {
  width: 470px;
}
.custom-rates-container ::ng-deep app-rates .app-rates .remove-addition-field {
  right: 0px !important;
}
